import React from 'react';
import { Link } from 'react-router-dom';
import { motion } from 'framer-motion';

const itemVariants = {
  hidden: { opacity: 0, y: 20 },
  visible: (i) => ({
    opacity: 1,
    y: 0,
    transition: { delay: i * 0.1, duration: 0.4 }
  })
};

function Home() {
  const categorias = [
    { to: "/infraestrutura", icon: "bi bi-hdd-network", label: "Infraestrutura" },
    { to: "/seguranca", icon: "bi bi-shield-lock", label: "Segurança" },
    { to: "/suporte", icon: "bi bi-headset", label: "Suporte" },
    { to: "/lgpd", icon: "bi bi-file-earmark-lock2", label: "LGPD" },
    { to: "/redes", icon: "bi bi-diagram-3", label: "Redes" },
    { to: "/cloud", icon: "bi bi-cloud", label: "Cloud" },
  ];

  return (
    <div className="container text-center px-3 fade-in">
      <motion.div
        initial={{ opacity: 0, y: -30 }}
        animate={{ opacity: 1, y: 0 }}
        transition={{ duration: 0.7 }}
        className="intro-card p-4 rounded-4 shadow-lg mb-4"
        style={{
          backgroundColor: ' rgb(42 42 42 / 76%)',
          marginTop: '30px',
          backdropFilter: 'blur(8px)',
          border: '1px solid rgba(255, 255, 255, 0.1)'
        }}
      >
        <h1 className="home-title mb-3 text-white">InfoServiceBarreiras</h1>
        <p className="lead text-white-50">
          Soluções de TI para um mundo em constante evolução. Atuamos com excelência em redes, segurança, suporte e infraestrutura inteligente.
        </p>
      </motion.div>

      <motion.div
        className="categoria-box"
        initial="hidden"
        animate="visible"
      >
        {categorias.map((cat, i) => (
          <motion.div
            key={cat.to}
            custom={i}
            variants={itemVariants}
            className="d-flex justify-content-center"
          >
            <Link to={cat.to} className="categoria-item w-100">
              <i className={cat.icon}></i>
              <span>{cat.label}</span>
            </Link>
          </motion.div>
        ))}
      </motion.div>
    </div>
  );
}

export default Home;
